export default "__VITE_ASSET__CnBtMS0Q__"